import React from 'react';
import { BotIcon, BoxIcon, CogIcon, FlaskConicalIcon, LightbulbIcon, RocketIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';
const ICONS = {
  box: BoxIcon,
  cog: CogIcon,
  bulb: LightbulbIcon,
  bot: BotIcon,
  flask: FlaskConicalIcon,
  rocket: RocketIcon
};

/* Mismos colores que los lomos de los tomos en la imagen del pack */
const TOMO_COLORS = ['bg-brand-blue text-white', 'bg-brand-orange text-brand-navy', 'bg-brand-green text-brand-navy', 'bg-brand-violet text-white', 'bg-brand-yellow text-brand-navy', 'bg-brand-navy text-white'];
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-brand-navy" data-id="element-154" data-mp="5w2w5mcemk2g">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-155" data-mp="ktmyelhx214x">
        <p className="font-sub text-sm font-bold leading-tight text-brand-yellow" data-id="element-156" data-mp="fu0lye9wwox6">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-1.5 font-display text-[1.75rem] leading-[1.05] text-white sm:text-5xl" data-id="element-157" data-mp="36cgpf1vjas8k">
          6 tomos en un solo sistema,{' '}
          <span className="text-brand-yellow" data-id="element-158" data-mp="3f9qzwl0j2dcf">
            creados para aprender, construir y descubrir jugando.
          </span>
        </h2>
        <p className="mt-1 font-sans text-xs font-extrabold uppercase leading-tight text-brand-orange sm:text-sm" data-id="element-159" data-mp="3p9hwqtck94fo">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-sm leading-snug text-white/90" data-id="element-160" data-mp="3u704whir7fmm">
          No es simplemente otro ebook de manualidades. Es una ruta de
          aprendizaje que reúne{' '}
          <strong className="font-bold text-brand-yellow" data-id="element-161" data-mp="6u7a5vz2fd24">36 proyectos creativos</strong>{' '}
          para que los niños exploren la ciencia, comprendan mecanismos y
          desarrollen sus propias ideas mientras construyen.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-162" data-mp="grbv5sh6d2hc">
          {tomos.map((tomo, i) => {
          const Icon = ICONS[tomo.icon];
          return <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full overflow-hidden rounded-xl border-2 border-brand-yellow bg-white text-left text-brand-navy" data-id="element-163" data-mp="27z19iie3pqw0" data-mpi={i}>
                <span className={`flex w-14 flex-shrink-0 flex-col items-center justify-center gap-0.5 ${TOMO_COLORS[i]}`} data-id="element-164" data-mp="2vn14juig43ge">
                  <span className="font-sub text-[10px] font-bold uppercase tracking-wider" data-id="element-165" data-mp="2rlfpq3mcpf3k">
                    Tomo
                  </span>
                  <span className="font-display text-3xl leading-none" data-id="element-166" data-mp="30lvvjjqkgybl">
                    {i + 1}
                  </span>
                  <Icon size={14} aria-hidden="true" data-id="element-167" data-mp="1b8iohmr2kw6s" />
                </span>
                <div className="p-2.5" data-id="element-168" data-mp="168w6l00aqrrn">
                  <h3 className="font-sub text-sm font-bold leading-tight" data-id="element-169" data-mp="169xnvm7woaht">
                    <span className="sr-only" data-id="element-170" data-mp="3hwrcmzc7cdyn">Tomo {i + 1} — </span>
                    {tomo.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-171" data-mp="3mu19v15u1tx1">
                    {tomo.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-172" data-mp="3d2n44bnafxvg">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}